import { create } from "zustand";
import { persist } from "zustand/middleware";

// In your store, change to consistent values
const useAppModeStore = create(
  persist(
    (set) => ({
      mode: "member", // default to member mode
      toggleMode: () =>
        set((state) => ({
          mode: state.mode === "work" ? "member" : "work",
        })),
      setMode: (mode) => set({ mode }),
    }),
    {
      name: "app-mode-storage",
    }
  )
);

export default useAppModeStore;
